import { useCallback, useMemo } from 'react';
import ValidationStatusIcon from './ValidationStatusIcon';

const ScopesValidations = ({ scopesValidations }) => {
  const { scopes, missingScopes, isLoading, isError } = scopesValidations;
  const isScopeValid = useCallback(
    scope => (isLoading ? undefined : !missingScopes.includes(scope)),
    [missingScopes, isLoading]
  );
  const scopesList = useMemo(() => {
    return scopes.map(scope => ({
      name: scope,
      isValid: isScopeValid(scope)
    }));
  }, [scopes, isScopeValid]);

  if (isError) return null;

  return (
    <div className='flex flex-col'>
      <ol className='list-inside list-decimal'>
        {scopesList.map(scopeItem => {
          return (
            <li key={scopeItem.name} className='flex items-center pb-2 gap-2'>
              <div className='mr-2 text-sm w-9/12'>{scopeItem.name}</div>
              <ValidationStatusIcon
                isValid={scopeItem.isValid}
                isLoading={isLoading}
              />
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default ScopesValidations;
